<template>
  <div id="subpage">
    <el-col :span="24" class="warp-breadcrum">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <b>机构管理</b>
        </el-breadcrumb-item>
        <el-breadcrumb-item>机构支付配置</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <div class="content">
      <div class="xcx-head">
        <div style="display: flex">
          <span>小程序支付配置</span>
        </div>
      </div>
      <div class="xcx-content">
        <el-form
          ref="form_data"
          :model="form_data"
          :rules="rules"
          label-width="200px"
          style="width: 50%"
        >
          <el-form-item label="小程序APPID：" prop="WECHAT_MINI_PROGRAM_APPID">
            <el-input
              v-model="form_data.WECHAT_MINI_PROGRAM_APPID"
              placeholder="请输入小程序APPID"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="小程序APPSECRET："
            prop="WECHAT_MINI_PROGRAM_SECRET"
          >
            <el-input
              v-model="form_data.WECHAT_MINI_PROGRAM_SECRET"
              placeholder="请输入小程序APPSECRET"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商户MCHID："
            prop="WECHAT_OFFICIAL_ACCOUNT_MCHID"
          >
            <el-input
              v-model="form_data.WECHAT_OFFICIAL_ACCOUNT_MCHID"
              placeholder="请输入商户MCHID"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商户支付KEY："
            prop="WECHAT_OFFICIAL_ACCOUNT_AES_KEY"
          >
            <el-input
              v-model="form_data.WECHAT_OFFICIAL_ACCOUNT_AES_KEY"
              placeholder="请输入商户支付KEY"
            ></el-input>
          </el-form-item>
          <el-form-item class="mar_T_50">
            <el-button type="primary" @click="save()">保存</el-button>
            <el-button type="primary" @click="back()">返回</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: true,
      tableData: [],
      form_data: {
        WECHAT_MINI_PROGRAM_APPID: "",
        WECHAT_MINI_PROGRAM_SECRET: "",
        WECHAT_OFFICIAL_ACCOUNT_MCHID: "",
        WECHAT_OFFICIAL_ACCOUNT_AES_KEY: "",
      },
      rules: {
        WECHAT_MINI_PROGRAM_APPID: [
          { required: true, message: "请输入小程序APPID", trigger: "blur" },
        ],
        WECHAT_MINI_PROGRAM_SECRET: [
          { required: true, message: "请输入小程序APPSECRET", trigger: "blur" },
        ],
        WECHAT_OFFICIAL_ACCOUNT_MCHID: [
          { required: true, message: "请输入商户MCHID", trigger: "blur" },
        ],
        WECHAT_OFFICIAL_ACCOUNT_AES_KEY: [
          { required: true, message: "请输入商户支付KEY", trigger: "blur" },
        ],
      },
      page: 0,
      count: 0,
      limit: 10,
      id: 0,
      uId: 0,
    };
  },
  //进入页面加载
  mounted: function () {
    var that = this;
    var that = this;
    var query = that.$route.query;
    if (query.uId) {
      that.uId = query.uId;
    }
    if (query.id) {
      that.id = query.id;
      that.getDetail();
    } else {
      that.loading = false;
    }
  },
  methods: {
    /**
     * 获取详情
     */
    getDetail() {
      var that = this;
      that.axios
        .post("/setting/getWechat", {
          uid: that.uId,
          id: that.id,
        })
        .then((res) => {
          that.form_data = res.data;
          that.loading = false;
        });
    },
    save() {
      const that = this;
      that.$refs.form_data.validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.form_data;
        var url = "/manage/store";
        if (that.uId) {
          formData.uId = that.uId;
          formData.id = that.id;
          url = "/setting/wechat";
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.uId ? "修改成功" : "添加成功");
          that.back();
        });
      });
    },
    back() {
      var that = this;
      that.$router.push({
        path: "/manage/setting",
        query: {
          id: that.uId,
        },
      });
    },
  },
};
</script>
<style>
</style>